module.exports = __webpack_public_path__ + "static/img/zl1.6097da4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/zl1.png
// module id = 3SG7
// module chunks = 7